import React from "react";

export function Gap5() {
    return <div className="gap" style={{ width: 5, height: 5, flexShrink: 0 }} />;
}

export function Gap10() {
    return <div className="gap" style={{ width: 10, height: 10, flexShrink: 0 }} />;
}

export function Gap20() {
    return <div className="gap" style={{ width: 20, height: 20, flexShrink: 0 }} />;
}

export function Gap30() {
    return <div className="gap" style={{ width: 30, height: 30, flexShrink: 0 }} />;
}

export function Gap50() {
    return <div className="gap" style={{ width: 50, height: 50, flexShrink: 0 }} />;
}

export function Gap(props) {
    return (
        <div
            className="gap"
            style={{ width: props.size, height: props.size }}
        />
    );
}

export function FlexSpacer(props) {
    return <div style={{ flexGrow: 2 }}>{props.children}</div>;
}

